export default import.meta.ROLLDOWN_FILE_URL_PWd8aapBt1YfLvgRaedarQ